import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'admin-pages-contact-administrator.page-header',
		defaultMessage: 'Contact Jira Administrators',
		description: 'Header of Contact Jira Administrator Page',
	},
	noContactFormConfirgured: {
		id: 'admin-pages-contact-administrator.no-contact-form-confirgured',
		defaultMessage:
			'Your Jira administrator hasn’t configured this form yet. Reach out to your admin.',
		description: 'Contact Administrator form is not configured by admin',
	},
});
